export const typeMap: Record<string, string[]> = {
    senior: ['Admin', 'senior'],
    operator: ['Member', 'operator'],
    clientManager: ['Super Admin', 'client-manager'],
    opertor: ['Operator', 'operator'],
};
